export const SET_PAGE = "SET_PAGE";
export const SET_SIDEBAR = "SET_SIDEBAR";

export const setPage = (payload) => ({payload, type: SET_PAGE});
export const setSidebar = (payload) => ({payload, type: SET_SIDEBAR});
